/**
 * US IANA options for company / org clocks.
 * Phoenix is a choice. Never a missing-zone fallback.
 */

export const US_IANA_TIMEZONES = [
  { value: 'America/New_York', label: 'Eastern (America/New_York)' },
  { value: 'America/Detroit', label: 'Michigan (America/Detroit)' },
  { value: 'America/Indiana/Indianapolis', label: 'Indiana (America/Indiana/Indianapolis)' },
  { value: 'America/Kentucky/Louisville', label: 'Kentucky (America/Kentucky/Louisville)' },
  { value: 'America/Chicago', label: 'Central (America/Chicago)' },
  { value: 'America/Denver', label: 'Mountain (America/Denver)' },
  { value: 'America/Boise', label: 'Idaho (America/Boise)' },
  { value: 'America/Phoenix', label: 'Arizona (America/Phoenix)' },
  { value: 'America/Los_Angeles', label: 'Pacific (America/Los_Angeles)' },
  { value: 'America/Anchorage', label: 'Alaska (America/Anchorage)' },
  { value: 'Pacific/Honolulu', label: 'Hawaii (Pacific/Honolulu)' }
];

export const US_STATE_IANA = {
  CA: 'America/Los_Angeles',
  WA: 'America/Los_Angeles',
  OR: 'America/Los_Angeles',
  NV: 'America/Los_Angeles',
  AZ: 'America/Phoenix',
  CO: 'America/Denver',
  MT: 'America/Denver',
  NM: 'America/Denver',
  UT: 'America/Denver',
  WY: 'America/Denver',
  ID: 'America/Boise',
  TX: 'America/Chicago',
  IL: 'America/Chicago',
  MN: 'America/Chicago',
  WI: 'America/Chicago',
  IA: 'America/Chicago',
  MO: 'America/Chicago',
  AR: 'America/Chicago',
  LA: 'America/Chicago',
  MS: 'America/Chicago',
  AL: 'America/Chicago',
  OK: 'America/Chicago',
  KS: 'America/Chicago',
  NE: 'America/Chicago',
  SD: 'America/Chicago',
  ND: 'America/Chicago',
  TN: 'America/Chicago',
  NY: 'America/New_York',
  FL: 'America/New_York',
  PA: 'America/New_York',
  OH: 'America/New_York',
  GA: 'America/New_York',
  NC: 'America/New_York',
  SC: 'America/New_York',
  VA: 'America/New_York',
  WV: 'America/New_York',
  MD: 'America/New_York',
  DE: 'America/New_York',
  NJ: 'America/New_York',
  CT: 'America/New_York',
  MA: 'America/New_York',
  RI: 'America/New_York',
  NH: 'America/New_York',
  VT: 'America/New_York',
  ME: 'America/New_York',
  MI: 'America/Detroit',
  IN: 'America/Indiana/Indianapolis',
  KY: 'America/Kentucky/Louisville',
  DC: 'America/New_York',
  AK: 'America/Anchorage',
  HI: 'Pacific/Honolulu'
};

/**
 * Create-time suggestion from a US state. Null when unknown.
 * Does not invent a clock on read.
 *
 * @param {string} [stateCode]
 * @returns {string|null}
 */
export function timezoneForUsState(stateCode) {
  if (!stateCode) return null;
  return US_STATE_IANA[String(stateCode).toUpperCase()] || null;
}
